<template>
  <div class="home">
    <div>
      Minjae Kwak
    </div>
    <div style="display:flex; flex-direction: row;">
      <div class="item">
        <router-link to="/pathlit">PathLit</router-link>
      </div>
      <div class="item">
        <router-link to="/tutorials">Tutorials</router-link>
      </div>
      <div class="item">
        <router-link to="/drifter">Drifter</router-link>
      </div>
      <div class="item">
        <router-link to="/chatdiary">Chat Diary</router-link>
      </div>
    </div>
  </div>
</template>

<style>
  .home{
    display:flex;
    justify-content: center;
    align-items: center;
    height:100%;

    flex-direction: column;
  }

  .item{
    margin:10px;
  }
</style>

<script>
// @ is an alias to /src

export default {
  name: 'home',
  components:{}
}
</script>
